import Delete from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import LockOutlined from '@mui/icons-material/LockOutlined';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import { t } from 'i18next';

import { FuelPriceIndex as FuelPriceIndexModel } from '~hooks/useFuelPriceIndices/models';

interface FuelPriceIndexRowProps {
  index: FuelPriceIndexModel;
  isSelected: boolean;
  onSelect: (id: string) => void;
  onEdit: (index: FuelPriceIndexModel, event: React.MouseEvent) => void;
  onDelete: (index: FuelPriceIndexModel, event: React.MouseEvent) => void;
}

export const FuelPriceIndexRow = ({
  index,
  isSelected,
  onSelect,
  onEdit,
  onDelete,
}: FuelPriceIndexRowProps) => {
  const theme = useTheme();

  return (
    <ListItemButton
      key={index.id}
      onClick={() => onSelect(index.id)}
      selected={isSelected}
      sx={{
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderRight: isSelected ? `2px solid ${theme.palette.primary.main}` : '',
        flex: 0,
        minHeight: 48,
        position: 'relative',
        '&:hover': {
          '& .action-buttons': {
            opacity: 1,
          },
        },
      }}
    >
      <ListItemText
        primary={index.name}
        slotProps={{ primary: { noWrap: true } }}
        sx={{ fontWeight: 600 }}
      />
      {index.system ? (
        <Tooltip title={t('administration.fuel_price_index.read_only')}>
          <LockOutlined fontSize="inherit" color="disabled" />
        </Tooltip>
      ) : (
        <Box
          className="action-buttons"
          sx={{
            position: 'absolute',
            right: 8,
            top: '50%',
            transform: 'translateY(-50%)',
            display: 'flex',
            gap: 0.5,
            opacity: 0,
            transition: 'opacity 0.2s',
          }}
        >
          <IconButton size="small" onClick={(e) => onEdit(index, e)}>
            <Edit fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={(e) => onDelete(index, e)}>
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      )}
    </ListItemButton>
  );
};
